























































import BaseComponent from '@/components/BaseComponent';
import { Component, Prop } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';

@Component
export default class EditGroup extends BaseComponent {
    // @Prop({ default: false }) private is_display!: boolean;
    @Prop({ default: '' }) private group_name!: string;
    @Prop({ default: -1 }) private group_id!: number;
    @Prop({ default: '' }) private group_office_code!: string;
    @Prop({ default: -1 }) private group_pref_num!: number;
    private isFormValid: boolean = false; // バリデーション状態でボタンを有効化する為のフラグ
    private is_display: boolean = true;
    private group_name_edit: string = '';
    private group_office_code_edit: string = '';
    private group_pref_edit: number = -1;
    private arrPref: any = [
        { name: '未選択', pref_num: -1 },
        { name: '北海道', pref_num: 0 },
        { name: '青森県', pref_num: 1 },
        { name: '岩手県', pref_num: 2 },
        { name: '宮城県', pref_num: 3 },
        { name: '秋田県', pref_num: 4 },
        { name: '山形県', pref_num: 5 },
        { name: '福島県', pref_num: 6 },
        { name: '茨城県', pref_num: 7 },
        { name: '栃木県', pref_num: 8 },
        { name: '群馬県', pref_num: 9 },
        { name: '埼玉県', pref_num: 10 },
        { name: '千葉県', pref_num: 11 },
        { name: '東京都', pref_num: 12 },
        { name: '神奈川県', pref_num: 13 },
        { name: '新潟県', pref_num: 14 },
        { name: '富山県', pref_num: 15 },
        { name: '石川県', pref_num: 16 },
        { name: '福井県', pref_num: 17 },
        { name: '山梨県', pref_num: 18 },
        { name: '長野県', pref_num: 19 },
        { name: '岐阜県', pref_num: 20 },
        { name: '静岡県', pref_num: 21 },
        { name: '愛知県', pref_num: 22 },
        { name: '三重県', pref_num: 23 },
        { name: '滋賀県', pref_num: 24 },
        { name: '京都府', pref_num: 25 },
        { name: '大阪府', pref_num: 26 },
        { name: '兵庫県', pref_num: 27 },
        { name: '奈良県', pref_num: 28 },
        { name: '和歌山県', pref_num: 29 },
        { name: '鳥取県', pref_num: 30 },
        { name: '島根県', pref_num: 31 },
        { name: '岡山県', pref_num: 32 },
        { name: '広島県', pref_num: 33 },
        { name: '山口県', pref_num: 34 },
        { name: '徳島県', pref_num: 35 },
        { name: '香川県', pref_num: 36 },
        { name: '愛媛県', pref_num: 37 },
        { name: '高知県', pref_num: 38 },
        { name: '福岡県', pref_num: 39 },
        { name: '佐賀県', pref_num: 40 },
        { name: '長崎県', pref_num: 41 },
        { name: '熊本県', pref_num: 42 },
        { name: '大分県', pref_num: 43 },
        { name: '宮崎県', pref_num: 44 },
        { name: '鹿児島県', pref_num: 45 },
        { name: '沖縄県', pref_num: 46 },
    ];
    created() {
        this.group_name_edit = this.group_name;
        this.group_office_code_edit = this.group_office_code;
        this.group_pref_edit = this.group_pref_num;
    }
    private closeDialog(v: boolean) {
        this.$emit('closeDialog', v);
    }

    // グループ編集
    private async groupEdit() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = {
                group_id: this.group_id,
                group_name: this.group_name_edit,
                office_code_list: this.group_office_code_edit,
                pref_num: this.group_pref_edit,
            };
            const resp: AxiosResponse<any> = await this.$http.post('group_edit.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    this.$emit('closeDialog', true);
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    this.validationErrors = resp.data.errors;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'グループ編集失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'グループ編集失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
}
